import { createSelector } from '@reduxjs/toolkit';
import { IState } from 'core';
import { ICommissionModeState } from './types';

export const commissionModeRootSelector = (state: IState) => state.commissionModeReducer;

export const isCommissionModeSelector = createSelector(
  commissionModeRootSelector,
  (state: ICommissionModeState) => state.isCommissionMode,
);
